"use client";

import { AlertCircle, Bot,Check,Hand, MessageSquare, MessageSquarePlus, MessagesSquare } from "lucide-react";
import { ReactNode, useState } from "react";
import Markdown from './Markdown/Markdown';
import { useUser } from "@/app/context/UserContext";
import { AccessType } from "@/app/constants/enums";
import { Conversation } from "@/app/models/interfaceConversation";
import ConversationForm from "../Conversation/ConversationForm";
import { listConversations } from "@/app/services/conversationService";
import { getCookie } from "@/app/helpers/cookies";
import { getcurrentUser } from "@/app/helpers/functions";

const WelcomeMessage = ({ message, typingEffect=true }: { message: string, typingEffect:boolean }) => {
  const { user, setUser, userProject,accessType,
      listConversation,listConversationLoading,
      currentConversation,setCurrentConversation,
      setListConversation,setListConversationLoading,
      addConversation, setAddConversation,setChangeConversation
   } = useUser();

  const [view, setView] = useState<"menu" | "list" | "form">("menu");
  

  const fetchConversations = async () => {
    setListConversationLoading(true);
    try {
      const res = await listConversations({
        user_id: getcurrentUser(accessType, userProject, user),
        project_id: userProject?.project?.id ?? "",
        company_code: userProject?.project?.company_code ?? "",
      }, user, setUser);
      setListConversation(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error(e);
    } finally {
      setListConversationLoading(false);
    }
  };

  
  return (
    <div className="mb-5 mt-5 flex animate-fadeIn justify-center">
      {accessType==AccessType.LogIn?( 
        currentConversation?
          <>
            <div className="mb-5 mt-5 flex animate-fadeIn relative w-full">
                <div className="flex items-center gap-4 p-4 rounded-3xl w-full n-chat-msj shadow bg-sky-50 text-sky-800 text-sm text-gray-700">
                  <Hand className="w-6 h-6 text-sky-800" />
                  <div>
                      <p className="font-semibold">Bienvenido</p>
                      <Markdown typingEffect={false} >{message}</Markdown>
                  </div>
                </div>
                <div className={`absolute bg-white  -bottom-10  border-b-[2px]
                              -left-5 border-l-[2px] 
                            transform -translate-y-1/2 
                            rounded-full  
                            border-slate-300
                            flex items-center 
                            justify-center`}> 
                              
                              <Bot strokeWidth={1.8} size={30} className="m-1"/>  
                            </div>
              </div>
          </>
        :
          <div className="flex flex-col items-center justify-center px-4 pt-5 w-full max-w-2xl">
              {view === "menu" && (
                <div className="w-full animate-fadeIn">
                  {/* Bienvenida */}
                  <h2 className="text-center text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-4">
                    Bienvenido
                  </h2> 
                  <div
                    className="flex items-center justify-center p-4 rounded-3xl n-chat-msj text-base text-gray-700 
                              mx-auto w-full max-w-lg text-center"
                  >
                    <Markdown typingEffect={typingEffect}>{message}</Markdown>
                  </div>
                  {/* Opciones */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-6 w-full">
                    {/* Continuar conversación */}
                    <div
                      onClick={() => setView("list")}
                      className="cursor-pointer group relative overflow-hidden px-4 py-3 bg-white border border-gray-200 
                                rounded-lg shadow-sm hover:shadow-md hover:border-blue-500 transition-all duration-200 
                                flex items-center justify-between w-full sm:w-1/2 min-w-[250px]"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-transparent opacity-50 group-hover:opacity-70 transition"></div>
                      <div className="relative flex items-center gap-3">
                        <div className=" flex items-center justify-center rounded-full bg-blue-100 group-hover:bg-blue-200 transition">
                          <MessagesSquare className="w-6 h-6 text-blue-600 m-4" />
                        </div>
                        <div className="text-left">
                          {currentConversation ? (
                            <>
                              <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 transition">
                                Continuar conversación
                              </h3>
                              {/*<p className="text-sm text-gray-500">
                                {currentConversation.name || `Conversación ${currentConversation.conversation_id.slice(0, 6)}`}
                              </p>*/}
                            </>
                          ) : (
                            <>
                              <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 transition">
                                Usar conversación
                              </h3>
                              <p className="text-sm text-gray-500">Selecciona una conversación previa del listado.</p>
                            </>
                          )}
                        </div>
                      </div>
                      <span className="relative text-blue-500 font-bold text-lg group-hover:translate-x-1 transition-transform">
                        →
                      </span>
                    </div>

                    {/* Nueva conversación */}
                    <div
                      onClick={()=>setAddConversation(true)/*() => setView("form")*/}
                      className="cursor-pointer group relative overflow-hidden px-4 py-3 bg-white border border-gray-200 
                                rounded-lg shadow-sm hover:shadow-md hover:border-green-500 transition-all duration-200 
                                flex items-center justify-between w-full sm:w-1/2 min-w-[250px]"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-transparent opacity-50 group-hover:opacity-70 transition"></div>
                      <div className="relative flex items-center gap-3">
                        <div className="flex items-center justify-center rounded-full bg-green-100 group-hover:bg-green-200 transition">
                          <MessageSquarePlus className="w-6 h-6 text-green-600 m-3" />
                        </div>
                        <div className="text-left">
                          <h3 className="font-semibold text-gray-900 group-hover:text-green-600 transition">
                            Nueva conversación
                          </h3>
                          <p className="text-sm text-gray-500">Crea una conversación personalizada.</p>
                        </div>
                      </div>
                      <span className="relative text-green-500 font-bold text-lg group-hover:translate-x-1 transition-transform">
                        →
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {view === "list" && (
                <div className="w-full max-w-2xl animate-fadeIn">
                  <button
                    onClick={() => setView("menu")}
                    className="group cursor-pointer bg-white border border-gray-200 rounded-full
                              shadow-sm flex items-center gap-2 text-gray-700 text-sm font-medium
                              transition-all duration-200 hover:bg-gray-50 hover:border-blue-400 
                              hover:shadow-md hover:text-blue-600 px-3 py-2 mb-5"
                  >
                    <span className="text-base transform transition-transform duration-200 group-hover:-translate-x-1 ml-2">←</span>
                    <span className="mr-4">Volver</span>
                  </button>

                  {listConversationLoading ? (
                    <p className="text-gray-500">Cargando conversaciones...</p>
                  ) : listConversation.length > 0 ? (
                    <div className="space-y-2 animate-fadeIn">
                      {listConversation.map((conv: Conversation) => {
                        const isActive = false;//currentConversation?.conversation_id === conv.conversation_id;

                        return (
                          <div
                            key={conv.conversation_id}
                            onClick={() => {setCurrentConversation(conv);setChangeConversation(true);setAddConversation(false);} }
                            className={`cursor-pointer rounded-lg border p-3 transition-all
                              ${
                                isActive
                                  ? "border-blue-500 bg-blue-50 shadow-sm"
                                  : "border-gray-200 bg-white shadow-sm hover:border-blue-400 hover:shadow-md"
                              }
                              flex justify-between items-center`}
                          >
                            <div className="flex flex-col">
                            <h4
                                  className={`font-medium text-sm text-ellipsis overflow-hidden whitespace-nowrap w-full max-w-full ${
                                    isActive ? "text-blue-700" : "text-gray-900 group-hover:text-blue-600"
                                  }`}
                                  title={conv.name || `Conversación ${conv.conversation_id.slice(0, 6)}`}
                                >
                                  {conv.name || `Conversación ${conv.conversation_id.slice(0, 6)}`}
                                </h4>
                              {conv.description && <p className="text-xs text-gray-500 line-clamp-2">{conv.description}</p>}
                            </div>
                            {isActive && <Check className="text-blue-600" />}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-gray-500">No tienes conversaciones previas.</p>
                  )}
                </div>
              )}

              {view === "form" && (
                <div className="w-full max-w-xl animate-fadeIn">
                  <button
                    onClick={() => setView("menu")}
                    className="group cursor-pointer bg-white border border-gray-200 rounded-full
                              shadow-sm flex items-center gap-2 text-gray-700 text-sm font-medium
                              transition-all duration-200 hover:bg-gray-50 hover:border-green-400 
                              hover:shadow-md hover:text-green-600 px-3 py-2 mb-5"
                  >
                    <span className="text-sm transform transition-transform duration-200 group-hover:-translate-x-1 ml-2">←</span>
                    <span className="mr-4">Volver</span>
                  </button>

                  <ConversationForm onClose={() => setView("menu")} onUpdateList={fetchConversations} editingConv={null} />
                </div>
              )}
          </div> 
      )
      :
        <>
           <div className="mb-5 mt-5 flex animate-fadeIn relative w-full">
              <div className="flex items-center gap-4 p-4 rounded-3xl w-full n-chat-msj shadow bg-sky-50 text-sky-800 text-sm text-gray-700">
                <Hand className="w-6 h-6 text-sky-800" />
                <div>
                    <p className="font-semibold">Bienvenido</p>
                    <Markdown typingEffect={false} >{message}</Markdown>
                </div>
              </div>
              <div className={`absolute bg-white  -bottom-10  border-b-[2px]
                            -left-5 border-l-[2px] 
                          transform -translate-y-1/2 
                          rounded-full  
                          border-slate-300
                          flex items-center 
                          justify-center`}> 
                            
                            <Bot strokeWidth={1.8} size={30} className="m-1"/>  
                          </div>
            </div>
        </>
      }
      
    </div>
  );
};

export default WelcomeMessage;
